export class StringUtils {

    static isEmpty(item: string | null | undefined) {
        return item === null || item === undefined || item.trim() === '';
    }

    static equalIgnoreCase(first: string, second: string) {
        return first.toLowerCase() === second.toLowerCase();
    }

    static isBlank(value: string | undefined | null) {
        return (!value || /^\s*$/.test(value));
    }

    static matchWord(sentence: string, wordPattern: string) {
        return !StringUtils.isEmpty(sentence) && new RegExp("\\b" + wordPattern + "\\b").test(sentence)
    }

    static removeComments(value: string): string {
        return value.replace(/\/\*[\s\S]*?\*\/|\/\/.*/g, '').trim();
    }
}
